module.exports = __webpack_public_path__ + "static/media/status-new.374fb826.svg";